import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles<Theme>(theme => ({
  phoneIcon: {
    marginRight: theme.spacing(1),
  },
  phoneText: {
    marginRight: theme.spacing(3),
  },
}));

export default styles;
